import React from 'react';
import { Link } from 'react-router-dom';
import BowlMark from './BowlMark';
import { BRAND, LINKS } from '../brand';
import './Footer.css';

const Footer = () => (
  <footer className="footer">
    <div className="container">
      <div className="footer-content">
        <div className="footer-section">
          <p className="footer-brand">
            <span className="logo-mark">
              <BowlMark size={20} decorative />
            </span>
            {BRAND.product}
          </p>
          <p>{BRAND.tagline}</p>
        </div>
        <div className="footer-section">
          <h2>Produit</h2>
          <ul>
            <li><a href="/#features">Fonctionnalités</a></li>
            <li><a href="/#wallet">Apple Wallet</a></li>
            <li><a href="/#how-to-use">Comment ça marche</a></li>
            <li>
              <a href={LINKS.manageCard} target="_blank" rel="noopener noreferrer">
                Gérer ma carte
              </a>
            </li>
          </ul>
        </div>
        <div className="footer-section">
          <h2>Légal</h2>
          <ul>
            <li><Link to="/privacy">Politique de confidentialité</Link></li>
            <li><a href="/#contact">Contact</a></li>
          </ul>
        </div>
      </div>
      <div className="footer-bottom">
        <p>
          © {new Date().getFullYear()} {BRAND.product}. Tous droits réservés.
        </p>
      </div>
    </div>
  </footer>
);

export default Footer;
